var $cd909f5ad67ac9ef$exports = {};
$cd909f5ad67ac9ef$exports = {
    "loading": `Laden...`,
    "loadingMore": `Mehr laden ...`
};


export {$cd909f5ad67ac9ef$exports as default};
//# sourceMappingURL=de-DE.mjs.map
